import React, {FC, useMemo} from "react";
import {InitiatorName, NotificationHeader, NotificationMessage, ProjectTitle, DivLink} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

export const NotificationChannelArchive: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.channelCommentInfo;
    const initiator = info?.initiator;
    const { t } = useTranslation()

    const channelName = useMemo(() => info?.teamName , [info])
    const channelId = useMemo(() => info?.teamId , [info])
    const initiatorId = useMemo(() => info?.initiator?.accountId , [info])
    const initiatorName = useMemo(() => `${info?.initiator?.name} ${info?.initiator?.surName}` , [initiator])

    const onUserClick = () => {
        window.open(CreateLinkTo.designer(initiatorId), '_blank')
    }

    const onChannelClick = () => {
        window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId)
    }

    if (!initiator) return null;

    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {' '}
            {t(`notifications.channel_member_add_1`)}
            {' '}
            <span onClick={onUserClick}>
                <InitiatorName>
                    {channelName}
                </InitiatorName>
            </span>
            {' '}
            {t(`notifications.channel_archive_2`)}
            {' '}
            <DivLink onClick={onChannelClick}>
                <ProjectTitle>
                    {initiatorName}
                </ProjectTitle>
            </DivLink>
        </NotificationMessage>
    </NotificationHeader>
}import React, {FC, useMemo} from "react";
import {InitiatorName, NotificationHeader, NotificationMessage, ProjectTitle, DivLink} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

export const NotificationChannelArchive: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.channelCommentInfo;
    const initiator = info?.initiator;
    const { t } = useTranslation()

    const channelName = useMemo(() => info?.teamName , [info])
    const channelId = useMemo(() => info?.teamId , [info])
    const initiatorId = useMemo(() => info?.initiator?.accountId , [info])
    const initiatorName = useMemo(() => `${info?.initiator?.name} ${info?.initiator?.surName}` , [initiator])

    const onUserClick = () => {
        window.open(CreateLinkTo.designer(initiatorId), '_blank')
    }

    const onChannelClick = () => {
        window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId)
    }

    if (!initiator) return null;

    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {' '}
            {t(`notifications.channel_member_add_1`)}
            {' '}
            <span onClick={onUserClick}>
                <InitiatorName>
                    {channelName}
                </InitiatorName>
            </span>
            {' '}
            {t(`notifications.channel_archive_2`)}
            {' '}
            <DivLink onClick={onChannelClick}>
                <ProjectTitle>
                    {initiatorName}
                </ProjectTitle>
            </DivLink>
        </NotificationMessage>
    </NotificationHeader>
}